<template>
    <div id="container" type="vprivacypolicy">
        <div class="page privacy-policy"  v-ga:request="{pageType:'vprivacypolicy', state: {}}" v-ga:page="{pageType:'vprivacypolicy', glb: glb, state: {}}">
            <mvtHeader />
            <div class="static-section">
                <div class="static-gs">
                    <div class="word-section">
                        <h1>{{molang('privacypolicy.title')}}</h1>
                        <p>
                            <span v-html="getContent('privacypolicy.content1')"></span>
                        </p>
                        <h2>{{molang('privacypolicy.scope.header')}}</h2>
                        <p>
                            <span v-html="getContent('privacypolicy.scope.content')"></span>
                        </p>
                        <h3>{{molang('privacypolicy.gdpr.header')}}</h3>
                        <p>
                            <span v-html="getContent('privacypolicy.gdpr.content')"></span>
                        </p>
                        <h3>{{molang('privacypolicy.1.question')}}</h3>
                        <p>
                            <span v-html="getContent('privacypolicy.1.content')"></span>
                        </p>
                        <h3>{{molang('privacypolicy.1.informationYouGiveUs.header')}}</h3>
                        <p>
                            <span v-html="getContent('privacypolicy.1.informationYouGiveUs.content')"></span>
                        </p>
                        <h3>{{molang('privacypolicy.1.automaticInformation.header')}}</h3>
                        <p>
                            <span v-html="getContent('privacypolicy.1.automaticInformation.content1')"></span>
                        </p>
                        <p>
                            <span v-html="getContent('privacypolicy.1.automaticInformation.content2')"></span>
                        </p>
                        <p>
                            <span v-html="getContent('privacypolicy.1.automaticInformation.content3')"></span>
                        </p>
                        <h3>{{molang('privacypolicy.1.googleDisplayAdvertising.header')}}</h3>
                        <p>
                            <span v-html="getContent('privacypolicy.1.googleDisplayAdvertising.content1')"></span>
                        </p>
                        <p>
                            <span v-html="getContent('privacypolicy.1.googleDisplayAdvertising.content2')"></span>
                        </p>
                        <p>
                            <span v-html="getContent('privacypolicy.1.googleDisplayAdvertising.content3')"></span>
                        </p>
                        <p>
                            <span v-html="getContent('privacypolicy.1.googleDisplayAdvertising.content4')"></span>
                        </p>
                        <p>
                            <span v-html="getContent('privacypolicy.1.googleDisplayAdvertising.content5')"></span>
                        </p>
                        <p>
                            <span v-html="getContent('privacypolicy.1.googleDisplayAdvertising.content6')"></span>
                        </p>
                        <h3>{{molang('privacypolicy.1.otherThirdPartyPartners.header')}}</h3>
                        <p>
                            <span v-html="getContent('privacypolicy.1.otherThirdPartyPartners.content')"></span>
                        </p>
                        <h3>{{molang('privacypolicy.2.question')}}</h3>
                        <p>
                            <span v-html="getContent('privacypolicy.2.content1')"></span>
                        </p>
                        <p>
                            <span v-html="getContent('privacypolicy.2.content2')"></span>
                        </p>
                        <p>
                            <span v-html="getContent('privacypolicy.2.content3')"></span>
                        </p>
                        <p>
                            <span v-html="getContent('privacypolicy.2.content4')"></span>
                        </p>
                        <p>
                            <span v-html="getContent('privacypolicy.2.content5')"></span>
                        </p>
                        <p>
                            <span v-html="getContent('privacypolicy.2.content6')"></span>
                        </p>
                        <p>
                            <span v-html="getContent('privacypolicy.2.content7')"></span>
                        </p>
                        <h3>{{molang('privacypolicy.1.otherThirdPartyPartners.header')}}</h3>
                        <p>
                            <span v-html="getContent('privacypolicy.1.otherThirdPartyPartners.content')"></span>
                        </p>
                        <h3>{{molang('privacypolicy.3.question')}}</h3>
                        <p>
                            <span v-html="getContent('privacypolicy.3.content1')"></span>
                        </p>
                        <p>
                            <span v-html="getContent('privacypolicy.3.content2')"></span>
                        </p>
                        <p>
                            <span v-html="getContent('privacypolicy.3.content3')"></span>
                        </p>
                        <p>
                            <span v-html="getContent('privacypolicy.3.content4')"></span>
                        </p>
                        <h3 id="calPrivacyRights">{{molang('privacypolicy.4.question')}}</h3>
                        <p>
                            <span v-html="getContent('privacypolicy.4.content1')"></span>
                        </p>
                        <p>
                            <span v-html="getContent('privacypolicy.4.content2')"></span>
                        </p>
                        <p>
                            <i><span v-html="getContent('privacypolicy.4.info')"></span></i>
                        </p>
                        <p>
                            <span v-html="getContent('privacypolicy.4.content3')"></span>
                        </p>
                        <p>
                            <span v-html="getContent('privacypolicy.4.link')"></span>
                        </p>
                        <h3>{{molang('privacypolicy.5.question')}}</h3>
                        <p>
                            <span v-html="getContent('privacypolicy.5.content')"></span>
                        </p>
                        <h3>{{molang('privacypolicy.6.question')}}</h3>
                        <p>
                            <span v-html="getContent('privacypolicy.6.content')"></span>
                        </p>
                        <p>
                            <span v-html="getContent('privacypolicy.content2')"></span>
                        </p>
                        <p>
                            <b>{{molang('privacypolicy.checkingCompanySpecific.header')}}</b>
                            <span v-html="getContent('privacypolicy.checkingCompanySpecific.content')"></span>
                        </p>
                        <p>
                            <b>{{molang('privacypolicy.honoringDoNotCall.header')}}</b>
                            <span v-html="getContent('privacypolicy.honoringDoNotCall.content')"></span>
                        </p>
                        <p>
                            <b>{{molang('privacypolicy.verbalWrittenDoNotCall.header')}}</b>
                            <span v-html="getContent('privacypolicy.verbalWrittenDoNotCall.content')"></span>
                        </p>
                        <p>
                            <b>{{molang('privacypolicy.ourAffiliatedEntities.header')}}</b>
                            <span v-html="getContent('privacypolicy.ourAffiliatedEntities.content')"></span>
                        </p>
                        <p>
                            <b>{{molang('privacypolicy.anyQuestions.header')}}</b>
                            <span v-html="getContent('privacypolicy.anyQuestions.content')"></span>
                        </p>
                        <p>
                            <span v-html="getContent('privacypolicy.updateDate')"></span>
                        </p>
                        <p>
                            <span v-html="getContent('privacypolicy.copyright')"></span>
                        </p>
                    </div>
                </div>
            </div>
            <mvtFooter />
        </div>
    </div>
</template>

<script src="./privacy-policy.js"></script>

<style lang="scss">
@use './privacy-policy.scss' as *;
</style>